import { Injectable, OnDestroy, inject } from '@angular/core';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import AircallWorkspace from 'aircall-everywhere';
import { Subject, takeUntil, withLatestFrom } from 'rxjs';

import { Environment } from '@troyai/envs';
import {
  AircallCallEnded,
  AircallEverywhereCallEndedEvent,
  AircallEverywhereUserLoggedInEvent,
  AircallUserLoggedIn,
  AircallUserLoggedOut,
  DialPhoneNumber,
} from '@troyai/portal/voice-calls/data-access';
import { TrackService } from '@troyai/tracking';
import { GetUserProfile, UserProfileState } from '@troyai/user-profile/data-access';

@Injectable({
  providedIn: 'root',
})
export class AircallService implements OnDestroy {
  private store = inject(Store);
  private actions$ = inject(Actions);
  private env = inject(Environment);
  private trackService = inject(TrackService);

  private aircallWorkspace: any;
  private destroy$ = new Subject<void>();
  userProfileData$ = this.store.select(UserProfileState.getUserProfileData);

  constructor() {
    this.actions$
      .pipe(
        ofActionSuccessful(DialPhoneNumber),
        withLatestFrom(this.userProfileData$),
        takeUntil(this.destroy$)
      )
      .subscribe(([action, userProfileData]) => {
        if (this.env.production) {
          this.dialNumber(action.payload.phoneNumber);
        } else {
          this.dialNumber(userProfileData?.phone_number || '');
        }
      });
  }

  public init(domElement: string) {
    this.store.dispatch(new GetUserProfile());

    this.aircallWorkspace = new AircallWorkspace({
      domToLoadWorkspace: domElement,
      size: 'auto',
      onLogin: (settings: { user: AircallEverywhereUserLoggedInEvent }) => {
        this.store.dispatch(new AircallUserLoggedIn(settings.user));
        this.setupListeners();
      },
      onLogout: () => {
        this.store.dispatch(new AircallUserLoggedOut());
      },
    });
  }

  private setupListeners() {
    if (!this.aircallWorkspace) {
      return;
    }

    // this.aircallWorkspace.on('incoming_call', (call: AircallEverywhereIncomingCallEvent) => {
    //   console.log('Incoming call:', call);

    //   this.trackService.trackEvent({
    //     eventName: 'Aircall event',
    //     eventProps: {
    //       name: 'incoming_call',
    //       call_id: call.call_id,
    //     },
    //   });
    //   this.store.dispatch(new AircallIncomingCall({ call }));
    // });

    // this.aircallWorkspace.on('call_end_ringtone', (call: AircallEverywhereCallEndRingtoneEvent) => {
    //   console.log('Call end ringtone:', call);

    //   this.trackService.trackEvent({
    //     eventName: 'Aircall event',
    //     eventProps: {
    //       name: 'call_end_ringtone',
    //       call_id: call.call_id,
    //     },
    //   });
    //   this.store.dispatch(new AircallCallEndRingtone({ call }));
    // });

    // this.aircallWorkspace.on('outgoing_call', (call: AircallEverywhereOutgoingCallEvent) => {
    //   console.log('Outgoing call:', call);

    //   this.trackService.trackEvent({
    //     eventName: 'Aircall event',
    //     eventProps: {
    //       name: 'outgoing_call',
    //       call_id: call.call_id,
    //     },
    //   });
    //   this.store.dispatch(new AircallOutgoingCallStarted({ call }));
    // });

    // this.aircallWorkspace.on(
    //   'outgoing_answered',
    //   (call: AircallEverywhereOutgoingAnsweredEvent) => {
    //     console.log('Outgoing call answered:', call);

    //     this.trackService.trackEvent({
    //       eventName: 'Aircall event',
    //       eventProps: {
    //         name: 'outgoing_answered',
    //         call_id: call.call_id,
    //       },
    //     });
    //     this.store.dispatch(new AircallOutgoingCallAnswered({ call }));
    //   }
    // );

    this.aircallWorkspace.on('call_ended', (call: AircallEverywhereCallEndedEvent) => {
      this.trackService.trackEvent({
        eventName: 'Aircall event',
        eventProps: {
          name: 'call_ended',
          call_id: call.call_id,
        },
      });
      this.store.dispatch(new AircallCallEnded({ call }));
    });
  }

  public dialNumber(number: string) {
    this.aircallWorkspace?.send(
      'dial_number',
      { phone_number: number },
      (success: boolean, data: any) => {
        if (success) {
          console.log('Dial successful');
        } else {
          console.error('Dial failed', data);
        }
      }
    );
  }

  ngOnDestroy() {
    this.destroy();
  }

  public destroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
